import React from "react";
import { FieldErrorsImpl, DeepRequired, FieldValues } from "react-hook-form";
import { getKey } from "../../services/util";
import { InformationCircleIcon } from "@heroicons/react/24/outline";

interface Option {
  id: number | string;
  name: string;
}

interface SelectFieldProps
  extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  register?: any;
  errors?: FieldErrorsImpl<DeepRequired<FieldValues>>;
  options: Option[];
  defaultOptionLabel?: string;
  helpText?: string;
}

const SelectField: React.FC<SelectFieldProps> = ({
  label,
  register,
  errors,
  options,
  defaultOptionLabel = "Select Option",
  helpText,
  ...props
}) => {
  const fieldName = register?.name;
  const random = `select-${Math.random().toString(36).slice(2)}`;
  const error = getKey(fieldName, errors);

  return (
    <div className="w-full">
      <div className="">
        {label && <div className="mb-2" ><label className="text-sm font-medium text-gray-700 dark:text-gray-200">
          {label}  <span className="text-red-700">*</span>
          {/* <span className="relative group mr-auto ml-2 mt-0 inline-block"> */}
          <span className="relative group ml-1 inline-block">
            <InformationCircleIcon className="w-4 h-4 text-slate-500 cursor-pointer inline" />

            {/* {helpText && <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 w-64 rounded-md bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 p-3 text-xs text-slate-700 dark:text-slate-200 shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-150 z-50 "> */}
            {helpText && <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 w-64 rounded-md bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 p-3 text-xs text-slate-700 dark:text-slate-200 shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-150 z-50">
              {helpText}</div>}
          </span>
        </label></div>}
        <select
          id={random}
          className={` 
            peer block w-full rounded-lg bg-transparent  text-sm
            focus:outline-none focus:ring-1  focus:ring-blue-500
            disabled:opacity-70 disabled:pointer-events-none
            px-3 py-2 border border-gray-300 dark:border-slate-600
          `}
          //${error
          //   ? "border-red-500 text-red-900 focus:border-red-500"
          //   :
          //   "border-gray-300 text-gray-900 focus:border-blue-600"
          // }
          // dark:bg-slate-700 dark:text-white dark:border-gray-600
          defaultValue=""
          {...register}
          {...props}
        >
          <option value="0">
            {defaultOptionLabel}
          </option>

          {options.map((opt) => (
            <option key={opt.id} value={opt.id}>
              {opt.name}
            </option>
          ))}
        </select>
      </div>

      {error?.message && (
        <p className="mt-1 text-xs text-red-600">
          {error.message.toString()}
        </p>
      )}
    </div>
  );
};

export default SelectField;
